export default __webpack_public_path__ + "static/top-watarproof-caption-7e5ffded184584ccda42e01c56efa944.svg";